
export default {
    namespaced: true,
    state: {
        collections:{}
    },
    mutations:{
        set_collections(state,collections){
            state.collections = collections
        },
        set_labelCollection(state,collection){
            state.collections[collection.collectionName] = collection.labels
        }
        
    },
    actions:{

    },
    getters:{
        getLabel: (state) => (config) => {
            const returnLabel = (input) => {
                if (input) {

                    if (config.params) {
                        config.params.forEach((param, i) => {
                            input = input.replace(`{${i}}`, param)
                        })
                    }

                    return input
                }
            
                if (config.allowEmpty && input !== undefined)
                    return input
            
                console.error("Missing label:", config.labelCollection + "." + config.labelKey)
                return input
            }
            return returnCollection(state.collections[config.labelCollection], config)
                ? returnLabel(state.collections[config.labelCollection][config.labelKey])
                : config.emptyIfMissing ? "" : config.labelKey
        },
        existLabel: (state) => (config) => {
            const returnLabel = (input) => {
                return input !== "" && input !== undefined
            }

            return returnCollection(state.collections[config.labelCollection], config)
                ? returnLabel(state.collections[config.labelCollection][config.labelKey])
                : false
        }
    }
}
           
const returnCollection = (input, config) => {
    if(!input) console.error("Missing label-collection:",config.labelCollection)
    return input
}
